import T from 'i18n-react';
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import validator from 'validator';
import { getCardTypeIdFromIFrame } from '../../constants/CardTypeConstants';
import { PaymentValidationResult } from '../../constants/PaymentValidationResultConstants';
import { PaymentVendorProcessType } from '../../constants/PaymentVendorProcessTypeConstants';
import * as AccountStore from '../../store/Account';
import * as CommonStore from '../../store/Common';
import * as PaymentStore from '../../store/Payment';
import ConfirmModal from '../shared/ConfirmModal';
import ExternalLink from '../shared/ExternalLink';
import LoadingButton from '../shared/LoadingButton';
import LoadingOverlay from '../shared/LoadingOverlay';
import MessageError from '../shared/MessageError';
import PaymentSummary from '../shared/PaymentSummary';
import SuggestedPayment from '../shared/SuggestedPayment';
import IFrameManager from './IFrameManager';
import { PaymentAccountOption } from './PaymentAccountOption';
import { PaymentAccountSingleValue } from './PaymentAccountSingleValue';
import PaymentSidebar from './PaymentSidebar';

const Scroll = require('react-scroll');
const card = require(`../../images/${process.env.REACT_APP_CLIENT}/card.png`);
const paymentIcon = require(`../../images/${process.env.REACT_APP_CLIENT}/payment-icon.png`);

const Recaptcha = require('react-recaptcha');

const PaySteps = Object.freeze({
    Step1PaymentSummary: 1,
    Step2PaymentSending: 2,
    Step3PaymentConfirmation: 3
});

class PayCreditCard extends Component {

    constructor(props) {
        super(props);

        this.cardNumberValueRef = React.createRef();
        this.expirationRef = React.createRef();
        this.ccvRef = React.createRef();
        this.recaptchaRef = React.createRef();

        this.state = {
            step: PaySteps.Step1PaymentSummary,
            sentToBackend: false,
            valid_captcha: false,
            anotherPaymentMethod: true,
            tenderTypeID: 1,
            amount: '',
            nameOnAccount: '',
            cardZipCode: '',
            open: false,
            //cardNumberValue, expiration and ccv are considered here only for validation purposes (VALUES ARE NOT STORED)
            fields: [
                { name: 'nameOnAccount', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, minTextWords: 2, onValidating: CommonStore.hasMinWordsAmount },
                { name: 'cardNumberValue', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, onValidating: CommonStore.isValidCreditCardNumber, isDomValue: true },
                { name: 'expiration', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, onValidating: CommonStore.isValidCreditCardExpDate, isDomValue: true },
                { name: 'ccv', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, onValidating: CommonStore.isValidCvv, isDomValue: true },
                { name: 'cardZipCode', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, onValidating: CommonStore.isValidZipCode },
                { name: 'amount', isRequired: true, isNumeric: true, minValue: 0 }

            ],
            //CV ZD14560 2020/03/26 adding this properties to handle client stripe token generation
            cardZipCodeStripe: '',
            paymentStripePK: this.props.getPaymentStripePK(),
            stripe: {},
            elements: {},
            cardNumberElement: {},
            cardExpiryElement: {},
            cardCvcElement: {},
            totalPayment: 0,
            accountPaymentDistributions: [],
            paymentChargeFee: {}
        };

        //CV ZD14560 2020/03/26 adding this validation if stripe PK is enable then load the stripe script, and build the respective objects
        if (this.state.paymentStripePK) {
            const script = document.createElement("script");
            script.src = "https://js.stripe.com/v3/";
            script.async = true;
            script.onload = () => {
                //Creating the main stripe objects
                this.setState({ stripe: window.Stripe(this.state.paymentStripePK) });
                this.setState({ elements: this.state.stripe.elements() });
                //Create cardnumber element (this is the main element)
                this.setState({ cardNumberElement: this.state.elements.create('cardNumber', { placeholder: ' ' }) });
                this.state.cardNumberElement.mount('#txtCreditCardStripe');
                //Create cardexpiry element
                this.setState({ cardExpiryElement: this.state.elements.create('cardExpiry', { placeholder: ' ' }) });
                this.state.cardExpiryElement.mount('#txtExpireStripe');
                //Create cardcvc element
                this.setState({ cardCvcElement: this.state.elements.create('cardCvc', { placeholder: ' ' }) });
                this.state.cardCvcElement.mount('#txtCcvStripe');
            };
            document.body.appendChild(script);
        }

    }

    verifyCallback = (response) => {
        if (response) {

            this.setState({ valid_captcha: true });

            if (!this.props.enableAuthenticatePaymentInfo) {
                this.props.authorizeAccountPaymentByPass();
            }
        }
        else {
            this.setState({ valid_captcha: false });
        }
    }

    expiredAuthPaymentRecaptcha = () => {
        this.setState({ valid_captcha: false });
        this.props.authorizeAccountPaymentExpired();
    }

    verifyCardInfo = () => {
        
        if (!this.props.accountPayCreditCardPaymentAccount.paymentAccountID && this.state.paymentStripePK) {
            var options = {
                address_zip: this.state.cardZipCodeStripe
            };
        
            this.state.stripe.createToken(this.state.cardNumberElement, options).then((result) => {
                if (result.error) {
                    
                    this.props.setPaymentError(result.error.message);
                } else {
                    this.setState({ paymentToken: result.token.id });
                    //this.setState({ cardNumberValue: '************' + result.token.card.last4 });
                    //this.setState({ expireMonth: result.token.card.exp_month });
                    //this.setState({ expireYear: result.token.card.exp_year });
                    this.setState({ cardZipCode: this.state.cardZipCodeStripe });
                    //this.setState({ ccv: 123 });

                    let normalizedCardData = {
                        cardNumberValue: '************' + result.token.card.last4,
                        expireMonth: result.token.card.exp_month,
                        expireYear: result.token.card.exp_year,
                        ccv: 123
                    };

                    this.props.authorizeAccountPayment({ ...this.state, ...normalizedCardData });
                }
            });

        }
        else {
            if (this.isFormValid()) {
                this.props.authorizeAccountPayment(this.state);
            }
        }    
    }

    componentWillMount = () => {
        Scroll.animateScroll.scrollToTop({ smooth: true, duration: 500 });
        document.title = T.translate('common.client') + ' | ' + T.translate('accountPay.title');

        // Reset global validation state to ensure we always start at Step 1
        this.props.resetPaymentValidation();

        // Initialize app and load account data
        this.props.init();
        this.props.setAccount();
        this.props.getI4GoAuthorizeClient();
    }

    componentDidMount = () => {
        const { companyID, suggestedPaymentObject, hasRequestedPaymentAccounts, account } = this.props;

        if (companyID) {
            let userName = account.accountNumber;
            if (account.person) {
                let person = account.person;
                userName = person.emailAddress;
            }

            const request = {
                actions: ['iFrameSettings'],
                companyID: companyID,
                accountID: account.accountID,
                accountNumber: account.accountNumber,
                userName: userName,
                tenderTypeID: 1, // Credit card
                paymentVendorProcessTypeID: PaymentVendorProcessType.RegularPayment, // One-time payment
                isPayment: true
            };

            this.props.runHostedPaymentPageActions(request);

            if (!hasRequestedPaymentAccounts) {
                this.props.getPaymentAccounts();
            }

            if (!suggestedPaymentObject || !suggestedPaymentObject.hasOwnProperty('suggestedPaymentAmount')) {
                this.props.getSuggestedPaymentObject();
            }

            if (this.props.systemProperties && this.props.systemProperties.isLoaded) {
                this.setState({
                    paymentChargeFee: this.getPaymentChargeFeeObj(this.props.systemProperties.creditCardCharge)
                });

                if (this.props.systemProperties.myAcctReCaptchaDisabled && !this.props.enableAuthenticatePaymentInfo) {
                    this.props.authorizeAccountPaymentByPass();
                }
            }
        }
    }

    componentDidUpdate = async (prevProps) => {
        const { account, companyID, useHostedPaymentPage, suggestedPaymentObject, hasRequestedPaymentAccounts, paymentAccounts, systemProperties } = this.props;

        // Check if the account number was just loaded or changed
        if (account.accountNumber && account.accountNumber !== prevProps.account.accountNumber) {

            // Update field validation after data is loaded
            let updatedFields = [...this.state.fields];
            var field = updatedFields[5];
            var isPrepay = account.accountBillingTypeID === 1;
            field.minValue = isPrepay ? systemProperties.myAcctAutopayMinimumPayment : 0;

            this.setState({ fields: updatedFields });

            const accountsWereCleared = !hasRequestedPaymentAccounts && !prevProps.hasRequestedPaymentAccounts;

            if (accountsWereCleared) {
                // Payment accounts were cleared (e.g., after logout or navigation), trigger reload
                this.props.getPaymentAccounts();
            }

            if (!suggestedPaymentObject || !suggestedPaymentObject.hasOwnProperty('suggestedPaymentAmount')) {
                this.props.getSuggestedPaymentObject();
            }
        }

        // Check if companyID has just arrived
        if (companyID && companyID !== prevProps.companyID) {

            let userName = account.accountNumber;
            if (account.person) {
                let person = account.person;
                userName = person.emailAddress;
            }

            const request = {
                actions: ['iFrameSettings'],
                companyID: companyID,
                accountID: account.accountID,
                accountNumber: account.accountNumber,
                userName: userName,
                tenderTypeID: 1,
                paymentVendorProcessTypeID: PaymentVendorProcessType.RegularPayment,
                isPayment: true
            };

            await this.props.runHostedPaymentPageActions(request);
        }

        // Update payment charge fee when system properties load
        if (systemProperties.isLoaded && !prevProps.systemProperties.isLoaded) {
            this.setState({ 
                paymentChargeFee: this.getPaymentChargeFeeObj(systemProperties.creditCardCharge) 
            });

            if (this.props.systemProperties.myAcctReCaptchaDisabled && !this.props.enableAuthenticatePaymentInfo) {
                this.props.authorizeAccountPaymentByPass();
            }
        }

        // Handle hosted payment page validation
        if (this.state.step === PaySteps.Step1PaymentSummary) {
            const { paymentValidationResult } = this.props;

            if (useHostedPaymentPage && paymentValidationResult === PaymentValidationResult.Approved && this.props.paymentAttemptID > 0) {
                this.setState({ step: PaySteps.Step2PaymentSending });
            }
        }

        // Scroll to errors
        if (this.props.paymentErrorMessage) {
            Scroll.animateScroll.scrollToBottom({ smooth: true, duration: 500 });
        }
    }

    onChange = (e) => {
        let fields = this.state.fields.filter(x => x.name === e.target.name);
        if (fields && fields.length === 1) {
            let field = fields[0];
            var idx = this.state.fields.indexOf(field);

            if (field.isRequired && field.isRequiredError && e.target.value) {
                field.isRequiredError = false;
            }

            if (field.isNumeric && e.target.value) {
                e.target.value = CommonStore.getNumericInputText(e.target.value);
            }

            if (field.isNumeric && e.target.value) {
                if (validator.isDecimal(e.target.value)) {
                    field.isNumericError = false;
                }

                if (field.minValue && parseFloat(e.target.value) >= field.minValue) {
                    field.isMinimumAmountError = false;
                }
            }

            if (field.onValidating) {
                field.onValidating(field, e, this.props);
            }

            fields = this.state.fields;
            fields[idx] = field;

            this.setState({ fields });

            if (field.isDomValue) {
                return;
            }
        }

        this.setState({ [e.target.name]: e.target.value });
    }    

    onTokenizeCreditDetailsClick = (e) => {
        this.setState({ tokenizeCreditDetails: !this.state.tokenizeCreditDetails });
    }

    isFormValid = () => {

        var formData = { ...this.state } ;
        var valid = true;

        if (!formData.anotherPaymentMethod && !this.props.accountPayCreditCardPaymentAccount) {
            return false;
        }

        this.state.fields.map((field) => {

            if (field.conditionField && field.conditionValue === formData[field.conditionField]) {

                if (field.isDomValue) {
                    field.value = this[field.name + 'Ref'].current.value;//e.g.: this.cardNumberValueRef.current.value
                } else {
                    field.value = formData[field.name];
                }

                field.isRequiredError = false;

                if (field.isRequired && !field.value) {
                    field.isRequiredError = true;
                    valid = false;
                }

                if (field.isNumeric && field.value) {
                    if (!validator.isDecimal(field.value)) {
                        field.isNumericError = true;
                        valid = false;
                    }

                    if (field.minValue && parseFloat(field.value) < field.minValue) {
                        field.isMinimumAmountError = true;
                        valid = false;
                    }
                }

                if (field.onValidating) {
                    valid = valid && field.onValidating(field, undefined, this.props);
                }

                if (field.isDomValue) {
                   delete field.value;
                }
            }

        });

        this.setState(formData);

        if (valid) {
            this.props.setPaymentError('');
        } else {
            this.props.setPaymentError(T.translate("common.thereAreMissingFields"));
        }

        return valid;
    }

    pay = () => {
        // Check if amount is zero or empty
        const paymentAmount = this.state.totalPayment || this.state.amount;
        if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
            this.props.setPaymentError(T.translate('accountPay.amountMustBeGreaterThanZero') || 'Payment amount must be greater than zero to proceed.');
            return;
        }
        
        // Check if using iframe hosted payment page
        if (this.props.useHostedPaymentPage && this.state.iFramePaymentToken) {
            // Use iFrame token for payment
            let iFramePaymentData = {
                ...this.state,
                paymentToken: this.state.iFramePaymentToken,
                paymentMethod: 'iFrameCreditCard',
                amount: paymentAmount
            };
            
            this.postAccountPay(iFramePaymentData);
            return;
        }
        
        // If using hosted payment page but no token yet, show error
        if (this.props.useHostedPaymentPage && !this.props.accountPayCreditCardPaymentAccount.paymentAccountID && !this.state.iFramePaymentToken) {
            this.props.setPaymentError(T.translate('accountPay.pleaseCompletePaymentForm') || 'Please complete the payment form first.');
            return;
        }

        //CV ZD14560 2020/03/26 adding this validation if stripe PK is enable, and no already existend payment account selected, then the token will be generated here
        if (!this.props.accountPayCreditCardPaymentAccount.paymentAccountID && this.state.paymentStripePK) {
            var options = {
                address_zip: this.state.cardZipCodeStripe
            };
            //Create stripe token for this card, after that it is submited to the backend among with the other card information not sensitive
            this.state.stripe.createToken(this.state.cardNumberElement, options).then((result) => {
                if (result.error) {
                    // Inform the customer that there was an error generating the token.
                    this.props.setPaymentError(result.error.message);
                } else {
                    this.setState({ paymentToken: result.token.id });
                    //this.setState({ cardNumberValue: '************' + result.token.card.last4 });
                    //this.setState({ expireMonth: result.token.card.exp_month });
                    //this.setState({ expireYear: result.token.card.exp_year });
                    this.setState({ cardZipCode: this.state.cardZipCodeStripe });
                    //this.setState({ ccv: 123 });

                    let card = {
                        cardNumberValue: '************' + result.token.card.last4,
                        expireMonth: result.token.card.exp_month,
                        expireYear: result.token.card.exp_year,
                        ccv: 123
                    };

                    this.postAccountPay(card);
                }
            });

        }
        else
        {
            if (this.isFormValid()) {

                let amount = 0;

                if (this.props.showPaymentAmountWarning && this.props.account.accountBillingTypeID === 2 && amount > this.props.account.totalAmountDue) {
                    this.setState({ open: true });
                } else {
                    this.postAccountPay();
                }
            }
        }        
    }

    postAccountPay = (card) => {
        this.setState({ open: false }, () => {
            const {
                cardNumberValueRef,
                expirationRef,
                ccvRef,
                props: { postAccountPay },
                state,
            } = this;

            // Normalize input values (prefer card object if passed, fallback to refs)
            const normalizedCardData = {};

            if (card) {
                normalizedCardData.expireMonth = card.expireMonth;
                normalizedCardData.expireYear = card.expireYear;
                normalizedCardData.cardNumberValue = card.cardNumberValue;
                normalizedCardData.ccv = card.ccv;
            } else {
                if (cardNumberValueRef.current)
                    normalizedCardData.cardNumberValue = cardNumberValueRef.current.value;

                if (expirationRef.current)
                    normalizedCardData.expiration = expirationRef.current.value;

                if (ccvRef.current)
                    normalizedCardData.ccv = ccvRef.current.value;
            }

            postAccountPay({ ...state, ...normalizedCardData });
        });
    }

    goToDashboard = (e) => {
        this.props.toggleAccountPaymentSuccessModal();
        this.props.setAccount();
        this.props.clearPaymentState();
        this.props.history.push('/myaccount/dashboard');
    }

    handleChange = (selectedOption) => {
        this.props.changeCreditCardPaymentAccount(selectedOption);
        this.setState({
            anotherPaymentMethod: false,
            valid_captcha: false  // Reset CAPTCHA when switching to stored payment method
        });
        // Reset authorization when switching payment methods
        this.props.authorizeAccountPaymentExpired();
        // Reset reCAPTCHA visually
        if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
    }

    handleClick = (e) => {
        e.preventDefault();
        this.props.changeCreditCardPaymentAccount({});
        this.setState({
            anotherPaymentMethod: true,
            valid_captcha: false  // Reset CAPTCHA when switching to new payment method
        });
        // Reset authorization when switching payment methods
        this.props.authorizeAccountPaymentExpired();
        // Reset reCAPTCHA visually
        if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
    }

    open = () => {
        this.setState({ open: true });
    }

    close = () => {
        this.setState({ open: false });
    }

    handleTotalAmountCalculation = (totalPaymentAmount, accountPaymentDistributions) => {
        this.setState({ totalPayment: totalPaymentAmount }, function () {
            this.setState({ accountPaymentDistributions: accountPaymentDistributions });
        });
    }

    getExpirationDateError = (field) => {
        if (field.isRequiredError) {
            if (field.isNotMinDateError) {
                return 'accountPay.notMinimumDate';
            }
            else {
                if (field.isInvalidDateFormatError) {
                    return 'accountPay.invalidDateFormat';
                }
            }
            return 'common.thisFieldIsRequired';
        }

        return '';
    }

    getCvvError = (field) => {
        if (field.isRequiredError) {
            if (field.isInvalidCvv) {
                return 'accountPay.invalidCvv';
            }
            return 'common.thisFieldIsRequired';
        }

        return '';
    }

    getZipCodeError = (field) => {
        if (field.isRequiredError) {
            if (field.isInvalidZipCode) {
                return 'accountPay.invalidZipCode';
            }
            return 'common.thisFieldIsRequired';
        }

        return '';
    }

    getCreditCardMask = (cardNumberValueRef) => {
        var cardNumber = cardNumberValueRef.current ? cardNumberValueRef.current.value : '';
        var cardInfo = CommonStore.getCardInfo(cardNumber, false);        
        return cardInfo.mask;
    }

    getPaymentChargeFeeObj = (chargeFeeFromInit) => {
        let paymentChargeFee = {
            paymentMethod: T.translate('suggestedPayment.paymentsIncursCreditCard'),
            chargeFee: chargeFeeFromInit
        }

        return paymentChargeFee;
    }

    next = async () => {
        var { step } = this.state;

        if (step === PaySteps.Step1PaymentSummary) {
            const { useHostedPaymentPage, paymentValidationResult } = { ...this.props };

            if (useHostedPaymentPage) {
                if (paymentValidationResult === PaymentValidationResult.Unset) {
                    const account = { ...this.props.account };
                    const tenderTypeID = parseInt(this.state.tenderTypeID);
                    const paymentVendorProcessTypeID = PaymentVendorProcessType.RegularPayment; // One-time payment

                    const request = {
                        actions: ['paymentValidation'],
                        accountID: account.accountID,
                        accountNumber: account.accountNumber,
                        companyID: this.props.companyID,
                        amount: this.state.totalPayment || this.state.amount || 0.0,
                        tenderTypeID,
                        paymentVendorProcessTypeID,
                        keepLoadingSpinner: true
                    };
                    await this.props.runHostedPaymentPageActions(request);
                }
            } else {
                this.setState({ step: PaySteps.Step2PaymentSending });
            }
        }
    }

    back = async () => {
        const { step } = this.state;
        const { useHostedPaymentPage } = { ...this.props };

        if (step === PaySteps.Step2PaymentSending && useHostedPaymentPage) {
            this.props.resetPaymentValidation();
        }

        this.setState({ step: step - 1 });
    }

    onIFrameLoaded = () => {
        if (!this.state.sentToBackend) {
            this.props.hideLoadingSpinner();
        }
    }

    // iFrame related methods
    onIFrameResponse = (response) => {
        this.props.setIFrameResponse(response);
        
        if (!response.error && response.token) {
            // Payment was successful, process it
            this.setState({ 
                iFramePaymentToken: response.token,
                iFramePaymentData: response 
            });
        }
    }

    onIFramePaymentSuccess = (response) => {

        let expireMonth = '';
        let expireYear = '';
        let state = { ...this.state };

        // Extract expireMonth and expireYear from cardExpDate (format: MMYY)
        if (response.cardExpDate && response.cardExpDate.length === 4) {
            expireMonth = response.cardExpDate.substring(0, 2); // First 2 characters (MM)
            expireYear = response.cardExpDate.substring(2, 4);  // Last 2 characters (YY)
        }
        
        // Prepare payment data with iframe token and hosted payment page response
        let paymentData = {
            ...this.state,
            paymentToken: response.token,
            paymentMethod: 'iFrameCreditCard',
            amount: state.totalPayment || state.amount,
            tenderTypeID: 1,
            // New parameters for hosted payment page - use the exact field names from requirements
            isHostedPaymentPageResponse: true,
            hostedPaymentPageResponse: response.transactionResponse || '',
            // Additional reference fields for tracking
            referenceNumber: `${response.vendor} Credit Card Payment - ${response.operation || 'CC'}`,
            notes: `${response.vendor} Payment - Card: ${response.cardNumber || 'N/A'}, Account: ${response.accountName || 'N/A'}`,
            // Add required card details for hosted payment page
            cardNumber: response.cardNumber || '',          // four last digits
            expireYear: expireYear,                         // e.g 29 (from cardExpDate)
            expireMonth: expireMonth,                       // e.g. 11 (from cardExpDate)
            
            // Convert cardType from iframe to cardTypeID for the API
            cardTypeID: response.cardType ? getCardTypeIdFromIFrame(response.cardType) : null
        };

        if (response.nameOnAccount)
            paymentData.nameOnAccount = response.nameOnAccount;

        this.setState({ sentToBackend: true });

        // Process the payment
        this.props.postAccountPay(paymentData);
    }

    render() {
        const isLoading = this.props.paymentLoading || this.props.authorizeAccountPaymentLoading || this.props.accountSummaryLoading;
        const amountToPay = this.state.totalPayment || this.state.amount || 0.0;
        const { suggestedPaymentObject, paymentAccounts, paymentStripePK = '' } = this.props;
        const isSelectedPaymentAccount = this.props.accountPayCreditCardPaymentAccount.paymentAccountID > 0;
        const hasPaymentStripePK = paymentStripePK !== '';

        return (
            <div className="payment-section">

                <div className="left-sidebar">
                    <div className="p-main">

                        <LoadingOverlay loading={isLoading} />

                        <div className="page-header">
                            <div className="page-title">{T.translate('accountPay.pageTitle')}</div>
                            <p className="lead text-dark">{T.translate('accountPay.welcomePaymentSystem', this.props.systemProperties)}</p>
                        </div>
                        <div className="diverter" />

                        <div id="divStep1PaymentSummary" className="step1Payment" style={{ display: this.state.step === PaySteps.Step1PaymentSummary ? 'block' : 'none' }}>
                            <h6 className="card-title">{T.translate('accountPay.infoAsOf')} {CommonStore.formatDate(new Date())}</h6>

                            <div className="card bl-blue mb-4 mb-sm-5">
                                <div className="card-body pay-card">
                                    <img src={card} alt="card" />
                                    {this.props.account.accountBillingTypeID === 1 &&
                                        <ul>
                                            <li>
                                                <span>{T.translate('accountPay.accountNumber')}</span>
                                                <strong>{this.props.account.accountNumber}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.customerName')}</span>
                                                <strong>{this.props.account.primaryPersonName}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.amountBelowThreshold')}</span>
                                                <strong>${CommonStore.formatDecimal(this.props.account.disconnectThreshold)}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.availableBalance')}</span>
                                                <strong className={this.props.account.availableBalance > 0 ? "text-success" : "text-danger"}>${CommonStore.formatDecimal(this.props.account.availableBalance)} {this.props.account.availableBalance > 0 && <span className="text-success font-weight-bold"> {T.translate('dashboard.credit')}</span>}</strong>
                                            </li>
                                        </ul>
                                    }

                                    {this.props.account.accountBillingTypeID !== 1 &&
                                        <ul>
                                            <li>
                                                <span>{T.translate('accountPay.accountNumber')}</span>
                                                <strong>{this.props.account.accountNumber}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.customerName')}</span>
                                                <strong>{this.props.account.primaryPersonName}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.pastDueCharges')}</span>
                                                <strong>${CommonStore.formatDecimal(this.props.account.pastDueAmount)}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.totalAccountBalance')}</span>
                                                <strong className={this.props.account.accountBalance < 0 ? "text-danger" : "text-success"}>${CommonStore.formatDecimal(this.props.invertBalance ? Math.abs(this.props.account.accountBalance) : this.props.account.accountBalance)} {this.props.account.accountBalance > 0 && <span className="text-success font-weight-bold"> {T.translate('dashboard.credit')}</span>}</strong>
                                            </li>
                                        </ul>
                                    }

                                </div>
                            </div>

                            <h6 className="card-title mb-4">{T.translate('accountPay.paymentAmount')}</h6>

                            <SuggestedPayment 
                                key={`suggested-${this.props.account.accountID || 'none'}`}
                                suggestedPaymentObject={suggestedPaymentObject}
                                onFinishTotalAmountCalculation={this.handleTotalAmountCalculation}
                                paymentChargeFee={this.state.paymentChargeFee} />

                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-lg-12">
                                    <PaymentSummary amount={amountToPay} />
                                </div>
                            </div>

                            <MessageError>{this.props.paymentErrorMessage}</MessageError>

                            <LoadingButton
                                className="btn btn-primary btn-lg pull-right"
                                disabled={isLoading || amountToPay <= 0}
                                loading={isLoading ? 'true' : 'false'}
                                onClick={this.next}>
                                {T.translate('quickPay.nextStep')}
                            </LoadingButton>
                        </div>

                        <div id="divStep2PaymentSending" style={{ display: this.state.step === PaySteps.Step2PaymentSending ? 'block' : 'none' }}>
                            <div className="custom-control custom-checkbox credit-card-checkbox-outer checked">
                                <div className="credit-card-paybox">

                                    <div className="row" style={{ marginTop: '20px' }}>
                                        <div className="col-lg-12">
                                            <PaymentSummary amount={amountToPay} />
                                        </div>
                                    </div>

                                    <div className="row">

                                        <div className="col-sm-6">
                                            <h6 className="card-title">{T.translate('accountPay.useStoredPaymentMethod')}</h6>
                                        </div>
                                        <div className="col-sm-6 text-left text-sm-right">
                                            <NavLink to="/myaccount/paymentmethods" className="payment-link mb-3 d-inline-block">
                                                <img src={paymentIcon} alt="payment" /><span>{T.translate('autopay.addPaymentMethod')}</span>
                                            </NavLink>
                                            &nbsp;&nbsp;
                                            {isSelectedPaymentAccount && <a href="#" onClick={this.handleClick} className="payment-link mb-3 d-inline-block"><span>{T.translate('accountPay.clearSelectedOption')}</span></a>}
                                        </div>

                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <Select
                                                    value={this.props.accountPayCreditCardPaymentAccount}
                                                    onChange={this.handleChange}
                                                    components={{ Option: PaymentAccountOption, SingleValue: PaymentAccountSingleValue }}
                                                    options={(paymentAccounts || []).filter(x => x.paymentAccountTypeID === 2 || x.paymentAccountTypeID === 3)}
                                                    isSearchable={false}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {!isSelectedPaymentAccount && !hasPaymentStripePK && <div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <h6 className="card-title">{T.translate('accountPay.orMakeOneTimePayment')}</h6>
                                            </div>
                                        </div>

                                        {/* Show iFrame component if useHostedPaymentPage is true, otherwise show regular form */}
                                        {this.props.useHostedPaymentPage && this.state.step === PaySteps.Step2PaymentSending ? (
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <IFrameManager
                                                        sourceName="PayCreditCard"
                                                        key={`creditcard-${this.props.account && this.props.account.accountID}`}
                                                        paymentMethod="CreditCard"
                                                        paymentProviderID={this.props.paymentProviderID}
                                                        paymentVendorProcessTypeID={PaymentVendorProcessType.RegularPayment}
                                                        amount={amountToPay}
                                                        sourceAccount={this.props.account}
                                                        onLoaded={this.onIFrameLoaded}
                                                        companyID={this.props.companyID}
                                                        content={this.props.hostedPaymentPageContent}
                                                        onIFrameResponse={this.onIFrameResponse}
                                                        onPaymentSuccess={this.onIFramePaymentSuccess}
                                                        setPaymentError={this.props.setPaymentError}
                                                        setIFrameToken={this.props.setIFrameToken}
                                                        hideBorder={true}
                                                        disabled={(!this.state.totalPayment || this.state.totalPayment == 0) && (!this.state.amount || this.state.amount == 0)}
                                                        paymentAttemptID={this.props.paymentAttemptID}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="nameOnAccount">{T.translate('accountPay.nameOnCard')}</label>
                                                            <input type="text" id="nameOnAccount" name="nameOnAccount" value={this.state.nameOnAccount} onChange={this.onChange} className={"form-control " + (this.state.fields[0].isRequiredError ? 'is-invalid' : '')} autoComplete="off" />
                                                            <div className="invalid-feedback">{T.translate('accountPay.holderNameRequired')}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group credit-card-input">
                                                            <label htmlFor="cardNumberValue">{T.translate('accountPay.cardNumber')}</label>
                                                            <InputMask ref={this.cardNumberValueRef} mask={this.getCreditCardMask(this.cardNumberValueRef)} placeholder="#### #### #### ####" id="cardNumberValue" name="cardNumberValue" onChange={this.onChange} className={"form-control " + (this.state.fields[1].isRequiredError ? 'is-invalid' : '')} autoComplete="off" />
                                                            <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-lg-3 col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="expiration">{T.translate('accountPay.expiration')}</label>
                                                            <InputMask ref={this.expirationRef} mask="99/99" placeholder="MM/YY" id="expiration" name="expiration" onChange={this.onChange} className={"form-control " + (this.state.fields[2].isRequiredError ? 'is-invalid' : '')} autoComplete="off" />
                                                            <div className="invalid-feedback">{T.translate(this.getExpirationDateError(this.state.fields[2]))}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="ccv">{T.translate('accountPay.securityCode')}</label>
                                                            <input type="number" ref={this.ccvRef} id="ccv" name="ccv" maxLength={4} onChange={this.onChange} className={"form-control " + (this.state.fields[3].isRequiredError ? 'is-invalid' : '')} autoComplete="off" max={4} />
                                                            <div className="invalid-feedback">{T.translate(this.getCvvError(this.state.fields[3]))}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="cardZipCode">{T.translate('accountPay.billingZip')}</label>
                                                            <input type="text" name="cardZipCode" id="cardZipCode" onChange={this.onChange} className={"form-control " + (this.state.fields[4].isRequiredError ? 'is-invalid' : '')} autoComplete="off" />
                                                            <div className="invalid-feedback">{T.translate(this.getZipCodeError(this.state.fields[4]))}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>}

                                    {!isSelectedPaymentAccount && hasPaymentStripePK && <div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <h6 className="card-title">{T.translate('accountPay.orMakeOneTimePayment')}</h6>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group credit-card-input">
                                                        <label htmlFor="cardNumberValue">{T.translate('accountPay.cardNumber')}</label>
                                                        <div id="txtCreditCardStripe" style={{ border: '1px solid #f1f3f4', height: '54px', padding: '18px 60px', borderRadius: '2rem', backgroundColor: '#f1f3f4' }} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="expiration">{T.translate('accountPay.expiration')}</label>
                                                        <div id="txtExpireStripe" style={{ border: '1px solid #f1f3f4', height: '54px', padding: '18px 17px', borderRadius: '2rem', backgroundColor: '#f1f3f4' }} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="ccv">{T.translate('accountPay.securityCode')}</label>
                                                        <div id="txtCcvStripe" style={{ border: '1px solid #f1f3f4', height: '54px', padding: '18px 17px', borderRadius: '2rem', backgroundColor: '#f1f3f4' }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="cardZipCodeStripe">{T.translate('accountPay.billingZip')}</label>
                                                        <input type="text" name="cardZipCodeStripe" id="cardZipCodeStripe" value={this.state.cardZipCodeStripe} onChange={this.onChange} className={"form-control"} autoComplete="off" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}

                                    <div className="row">
                                        <div className="col-sm-10">
                                            {!!this.props.systemProperties.creditCardCharge &&
                                                this.props.systemProperties.creditCardCharge > 0 &&
                                                <p>
                                                    {T.translate('quickPay.paymentusCreditCardFeeWarning', { paymentusCreditCardFee: this.props.systemProperties.creditCardCharge })}
                                                </p>
                                            }

                                            {/* Show reCAPTCHA when not using hosted payment page OR when using stored payment method */}
                                            {!this.props.systemProperties.myAcctReCaptchaDisabled && (!this.props.useHostedPaymentPage || isSelectedPaymentAccount) && (
                                                <Recaptcha
                                                    ref={this.recaptchaRef}
                                                    sitekey={this.props.systemProperties.reCaptchaKey}
                                                    verifyCallback={this.verifyCallback}
                                                    expiredCallback={this.expiredAuthPaymentRecaptcha}
                                                    expireTimeMs={10000}
                                                />
                                            )}
                                        </div>
                                        {this.props.enableAuthenticatePaymentInfo && !this.props.useHostedPaymentPage && <div className="col-sm-6">
                                            <LoadingButton
                                                type="button"
                                                className="btn btn-outline-dark m-2"
                                                loading={this.props.authorizeAccountPaymentLoading ? 'true' : 'false'}
                                                disabled={(!this.props.systemProperties.myAcctReCaptchaDisabled && !this.state.valid_captcha) || this.props.authPaymentExpired || this.props.authPaymentVerified}
                                                onClick={this.verifyCardInfo}>
                                                Authorize
                                            </LoadingButton>
                                        </div>}
                                    </div>

                                </div>
                            </div>

                            <div className="clearfix mb-4" />

                            {T.translate('accountPay.byClickingPaymentYouAgree') && <p>
                                {T.translate('accountPay.byClickingPaymentYouAgree')} <ExternalLink href={this.props.systemProperties.marketerTosUrl} className="a-link">{T.translate('accountPay.termsOfService')}</ExternalLink>
                                {T.translate('accountPay.andUnderstandThePrivacyStatement')} <NavLink to="/myaccount/plandocuments" className="a-link">{T.translate('accountPay.yourRightsAsCustomer')}</NavLink>
                            </p>}

                            {/* Hide tokenization checkbox when using hosted payment page */}
                            {!this.props.account.isCashOnly && this.props.authPaymentVerified && !isSelectedPaymentAccount && !this.props.useHostedPaymentPage && <div>
                                <div>
                                    <p>{T.translate("accountPay.tokenizeCreditDetails")}</p>
                                </div>

                                <div className="checkbox">
                                    <label>
                                        <input className="coupon_question sign-up-checkbox mr-1" name="tokenizeCreditDetails" id="tokenizeCreditDetails" value="1" type="checkbox" checked={this.state.tokenizeCreditDetails} onClick={this.onTokenizeCreditDetailsClick} />
                                        {T.translate("accountPay.agreeOnTokenizeCreditDetails")}
                                    </label>
                                </div>
                            </div>}

                            <button type="button" className="btn" disabled={isLoading} onClick={this.back}>{T.translate('common.back')}</button>

                            {/* Show submit button when not using hosted payment page OR when using stored payment method */}
                            {!this.props.account.isCashOnly && (!this.props.useHostedPaymentPage || isSelectedPaymentAccount) && (
                                <LoadingButton
                                    type="button"
                                    className="btn btn-primary btn-lg pull-right"
                                    disabled={this.props.paymentLoading || (!this.props.systemProperties.myAcctReCaptchaDisabled && !this.state.valid_captcha) || !this.props.authPaymentVerified || (!isSelectedPaymentAccount && !this.state.tokenizeCreditDetails)}
                                    loading={this.props.paymentLoading ? 'true' : 'false'}
                                    onClick={this.pay}>
                                    {T.translate('accountPay.submitPayment')}
                                </LoadingButton>
                            )}

                            <MessageError>{this.props.paymentErrorMessage}</MessageError>
                        </div>
                    </div>
                </div>

                <ConfirmModal
                    title={T.translate('accountPay.paymentAccepted')}
                    open={this.props.showAccountPaymentSuccessModal}
                    onToggle={this.goToDashboard}
                    loading={this.props.paymentLoading}>
                    <div>
                        <p>{T.translate('accountPay.yourPaymentHasBeenAccepted')}</p>
                        <p className="font-weight-bold">{T.translate('accountPay.yourPaymentConfirmationNumberIs')}</p>
                        <p>{this.props.accountPayConfirmationNumber}</p>
                    </div>
                </ConfirmModal>

                <ConfirmModal
                    title={T.translate('accountPay.paymentWarning')}
                    open={this.state.open}
                    onToggle={this.close}
                    onConfirm={this.postAccountPay}
                    confirmButtonText={T.translate('accountPay.yesSubmitPayment')}>
                        <div><p>{T.translate('accountPay.areYouSureWantPayMoreAmountDue')}</p></div>
                </ConfirmModal>

                <PaymentSidebar />
            </div>
        );
    }
}

export default connect(
    state => ({ ...state.account, ...state.common, ...state.payment }),
    dispatch => bindActionCreators({ ...AccountStore.actionCreators, ...CommonStore.actionCreators, ...PaymentStore.actionCreators }, dispatch)
)(PayCreditCard);
